import { FC, HTMLAttributes } from 'react'

export const ChevronUp: FC<HTMLAttributes<HTMLDivElement>> = ({ ...rest }) => (
  <div
    className="border-neutral-normal-lighter mb-5 hidden size-4 rotate-45 cursor-pointer border-t-2 border-l-2 lg:block"
    {...rest}
  />
)
